export class LoginRequestModel {
    constructor(obj) {
        this.userId = obj.userId;
        this.password = obj.password;
        this.culture = "ja-JP";
        this.isForceLogin = true;
    }
}